import {
  Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, Output,
  EventEmitter
} from '@angular/core';
import { CardStatisticsService, CountInfo } from '@ispm-client/modules/pan-cancer/services/card-statistics.service';
import { filter } from 'rxjs/operators';
import { QueryRegistrationTransformationService } from '@ispm-client/modules/pan-cancer/services/query-registration-transformation.service';
import { WidgetCountProcessorService } from '@ispm-client/modules/pan-cancer/services/widget-count-processor-service';
import {get} from 'lodash';

export const CARD_SERVICES = [ CardStatisticsService,
  QueryRegistrationTransformationService,
  WidgetCountProcessorService ];

@Component({
  selector: 'ispm-pan-cancer-card-header',
  templateUrl: './pan-cancer-card-header.component.html',
  styleUrls: ['./pan-cancer-card-header.component.scss'],
  providers: [ CARD_SERVICES ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PanCancerCardHeaderComponent implements OnInit {

  @Input()
  header: string;

  @Input()
  set formHolder(_formHolder: any) {
    this._formHolder = _formHolder;
  };

  @Output()
  countEmitter: EventEmitter<CountInfo> = new EventEmitter<CountInfo>();

  public _formHolder: any;

  public viewCount: number = 0;

  public showAllCount: number = 0;

  public countAvailable: boolean = false;

  public showAllDataAvailable: boolean = false;

  public fixedHiddenCount: number = 0;

  public showAllDataCount: number = 0;

  constructor( private cardStats: CardStatisticsService,
               private queryRegistration: QueryRegistrationTransformationService,
               private widgetCountProcessorService: WidgetCountProcessorService,
               private changeDetector: ChangeDetectorRef) {

  }

  ngOnInit() {
    this.prepareHeaderContent();
  }

  prepareHeaderContent() {

    if (this._formHolder && this._formHolder.hasOwnProperty('fixedHiddenCount')) {
      this.fixedHiddenCount = get(this._formHolder, 'fixedHiddenCount');
      if (this.fixedHiddenCount > 0) {
        this.showAllDataCount = this.fixedHiddenCount;
        this.showAllDataAvailable = true;
        this.changeDetector.markForCheck();
      }
    } else {
      this.cardStats.requestDataForForms(this._formHolder)
        .pipe(filter(value => !!value))
        .subscribe((countInfo: CountInfo) => {
          this.viewCount = countInfo.viewCount;
          this.showAllCount = countInfo.showAllCount;
          if(countInfo.noteCount) {
            this.showAllDataCount = countInfo.noteCount;
          } else {
            this.showAllDataCount = countInfo.showAllDataCount;

          }
          this.countAvailable = true;
          this.emitShowAllDataCount(countInfo);
          this.getShowAllCount();
          this.changeDetector.markForCheck();
        });
    }
  }

  /**
   * Get show all count
   */
  getShowAllCount() {
    if ((this.viewCount === this.showAllCount) || (this.showAllCount < this.viewCount)) {
      this.countAvailable = false;
    }
  }

  /**
   * Method determines showAllDataCount is available/not available
   * @param {CountInfo} countInfo
   */
  emitShowAllDataCount(countInfo: CountInfo) {
    if (countInfo['showAllDataCount'] > 0 || countInfo['noteCount']) {
      this.countEmitter.emit(countInfo);
      this.showAllDataAvailable = true;
    } else {
      this.showAllDataAvailable = false;
    }
  }




}
